/**
 * BankAccountsSection Component
 * Collapsible bank account listing within Cash & P&L tab
 */

import { SectionCard } from './SectionCard';
import { formatCurrency } from '@/utils/formatters';
import type { CashPositionResponse } from '@/api/cashApi';

interface BankAccountsSectionProps {
  bankBalances: CashPositionResponse['data']['bankBalances'];
}

export function BankAccountsSection({ bankBalances }: BankAccountsSectionProps) {
  return (
    <SectionCard
      title="Bank Accounts"
      badge={
        <span className="cash-pnl-dashboard__count">
          {bankBalances.length} accounts
        </span>
      }
    >
      {bankBalances.length > 0 ? (
        <div className="cash-pnl-dashboard__table">
          <div className="cash-pnl-dashboard__table-header">
            <span>Account</span>
            <span>Balance</span>
          </div>
          {bankBalances.map((account, index) => (
            <div key={account.accountId || account.name || index} className="cash-pnl-dashboard__table-row">
              <span className="cash-pnl-dashboard__account-name">
                {account.name}
                <span className="cash-pnl-dashboard__account-code">{account.code}</span>
              </span>
              <span className="cash-pnl-dashboard__balance">
                {formatCurrency(account.balance)}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="cash-pnl-dashboard__empty">No bank accounts found</p>
      )}
    </SectionCard>
  );
}
